export const UI_EXPERIMENT_STORAGE_KEY = "ui_layout_variant";
export const UI_EXPERIMENT_PARAM = "sid";
export const UI_EXPERIMENT_PARAM_VALUE = "7f3ad1c092";
export const UI_EXPERIMENT_TTL_MS = 24 * 60 * 60 * 1000;
